module.exports = __webpack_public_path__ + "img/globe2.b76e4c6e.svg";